module.exports = __webpack_public_path__ + "static/media/shown.df119017.svg";